import { OrganizationFilterType } from "@/components/search/OrganizationFilter.vue";
import { DateFilterType } from "./DateFilterType";
import { IndexableEntityType } from "./IndexableEntityTypes";

export interface SearchRequest {
	searchTerm?: string | null;
	contentTypes?: IndexableEntityType[] | null;
	entityType?: IndexableEntityType | null;
	statuses?: string[] | null;
	customerIds?: string[] | null;
	userIds?: string[] | null;
	// Ids of the users who created the entity. The Projects page's "Creator" filter sends this;
	// userIds means "any user associated with it" (creator, assignee, participant, share recipient).
	createdByIds?: string[] | null;
	parentIds?: string[] | null;
	labels?: string[] | null;
	startDate?: Date | null;
	endDate?: Date | null;
	dateFilter?: DateFilterType | null;
	page: number;
	pageSize: number;
	entitySearch: boolean;
	orderBy?: string | null;
	orderByDescending?: boolean;
	tab?: string | null;
	organization?: OrganizationFilterType | null;
	organizationId?: string | null;
	score?: boolean;
	latitude?: number | null;
	longitude?: number | null;
	projectId?: string | null;
	shareId?: string | null;
}

export function searchRequestToQueryString(searchRequest: SearchRequest): string {
	const keys = Object.keys(searchRequest);
	const queryString = keys.map((key) => {
		const value = searchRequest[key as keyof SearchRequest];
		if (key === "orderByDescending" && typeof value === "boolean") {
			return `${key}=${value}`;
		}
		if (!!value && value !== "") {
			if (Array.isArray(value) && value.length > 0) {
				return `${key}=${value.join(",")}`;
			} else if (value instanceof Date) {
				return `${key}=${value.getTime()}`;
			} else {
				return `${key}=${encodeURIComponent(String(value))}`;
			}
		}
	});

	return queryString.filter((x) => x).join("&");
}
